<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/reminders"></ion-back-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <div class="ion-padding ion-text-center" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading">
    <form #f="ngForm" class="ion-padding" (ngSubmit)="save(f)">
      <ion-grid>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <ion-list>
              <ion-item color="lightmimbo" lines="none" *ngIf="dogImgUrl.length>0">
                <ion-img class="header-image" [src]="dogImgUrl"></ion-img>
              </ion-item>
              <ion-item color="lightmimbo">
                <ion-label position="floating">Type*</ion-label>
                <ion-input name="reminderType" id="type-modal" required readonly="true"
                  [(ngModel)]="reminderType"></ion-input>
              </ion-item>
              <ion-item color="lightmimbo" *ngIf="reminderType=='Other'">
                <ion-label position="floating">Custom Name</ion-label>
                <ion-input name="customName" id="customName-modal" [(ngModel)]="customName"></ion-input>
              </ion-item>
              <ion-item color="lightmimbo">
                <ion-label position="floating">Pet*</ion-label>
                <ion-input name="dog" id="dog-modal" [(ngModel)]="dogName" required></ion-input>
              </ion-item>
              <ion-item color="lightmimbo">
                <ion-label position="floating">Date & Time*</ion-label>
                <ion-input name="reminderDate" required id="date-modal" readonly="true" [(ngModel)]="reminderDate"
                  #dateCtrl="ngModel"></ion-input>
              </ion-item>
              <ion-item color="lightmimbo">
                <ion-label position="floating">Remind Me</ion-label>
                <ion-select name="remindBefore" required interface="action-sheet" [(ngModel)]="reminderMins">
                  <ion-select-option value="0">As scheduled</ion-select-option>
                  <ion-select-option value="15">15 minutes before</ion-select-option>
                  <ion-select-option value="60">1 hour before</ion-select-option>
                  <ion-select-option value="180">3 hours before</ion-select-option>
                  <ion-select-option value="360">6 hours before</ion-select-option>
                  <ion-select-option value="1440">1 day before</ion-select-option></ion-select>
              </ion-item>
              <ion-item color="lightmimbo">
                <ion-label position="floating">Repeat</ion-label>
                <ion-select name="repeat" interface="action-sheet" required [(ngModel)]="repeatEvery">
                  <ion-select-option value="-1">Never</ion-select-option>
                  <ion-select-option value="1">Daily</ion-select-option>
                  <ion-select-option value="2">Weekly</ion-select-option>
                  <ion-select-option value="3">Monthly</ion-select-option>
                  <ion-select-option value="4">Every 3 Months</ion-select-option>
                  <ion-select-option value="5">Every 6 Months</ion-select-option>
                  <ion-select-option value="6">Yearly</ion-select-option>
                  >
                </ion-select>
              </ion-item>
              <ion-item color="lightmimbo">
                <ion-label position="floating">Notes</ion-label>
                <ion-textarea name="Notes" [(ngModel)]="notes" rows="5"></ion-textarea></ion-item>
            </ion-list>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2" class="ion-text-center">
            <ion-button color="primary" type="submit" [disabled]="!f.valid" class="btnDetail"><ion-icon name="save"
                slot="start"></ion-icon>Save</ion-button>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="eventId>0 && isComplete == false">
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2" class="ion-text-center">
            <ion-button color="primary" class="btnDetail" type="button" fill="outline"
              (click)="confirmComplete()"><ion-icon name="checkmark-done-outline" slot="start"></ion-icon>Mark As
              Completed</ion-button>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="eventId>0">
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2" class="ion-text-center">
            <ion-button color="primary" type="button" class="btnDetail" color="danger"
              (click)="deleteReminder()"><ion-icon name="trash-outline" slot="start"></ion-icon>Delete
              Reminder</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
    <ion-modal trigger="type-modal" #typePopup (willDismiss)="onTypeWillDismiss($event)">
      <ng-template>
        <ion-header>
          <ion-toolbar color="primary">
            <ion-buttons slot="start">
              <ion-button (click)="cancelType()"><ion-icon name="arrow-back-outline" slot="icon-only">
                </ion-icon></ion-button>
            </ion-buttons>
            <ion-title>Set Type</ion-title>
          </ion-toolbar>
        </ion-header>
        <ion-content>
          <ion-grid class="no-padding background-color">
            <ion-row style="padding-top: 24px">
              <ion-col *ngFor="let type of reminderTypes" (click)="setType(type.id)" sizeSm="4" sizeXs="6"
                class="ion-text-center">
                <div *ngIf="type.name != 'Birthday'" class="pointer">
                  <div class="square">
                    <img [src]="'../../../assets/images/remindertypes/' + type.imageName" />
                  </div>
                  <ion-text color="darkmimbo" class="font-size">{{type.name}}</ion-text>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-content>
      </ng-template>
    </ion-modal>
    <ion-modal trigger="date-modal" #datepopup (willDismiss)="onDateWillDismiss($event)">
      <ng-template>
        <ion-header>
          <ion-toolbar color="primary">
            <ion-buttons slot="start">
              <ion-button (click)="cancelDate()"><ion-icon name="arrow-back-outline" slot="icon-only">
                </ion-icon></ion-button>
            </ion-buttons>
            <ion-title>Set Date</ion-title>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding" color="lightmimbo">
          <div class="calendar">
            <ion-datetime [min]="dateToday" [(ngModel)]="datePopupVal" presentation="date-time"
              [max]="'2050-12-31'"></ion-datetime>
            <ion-button (click)="setDate()"><ion-icon name="calendar-outline" slot="start"></ion-icon>Set
              Date</ion-button>
          </div>
        </ion-content>
      </ng-template>
    </ion-modal>
    <ion-modal trigger="dog-modal" #dogPopup (willDismiss)="onDogWillDismiss($event)">
      <ng-template>
        <ion-header>
          <ion-toolbar color="primary">
            <ion-buttons slot="start">
              <ion-button (click)="cancelDog()"><ion-icon name="arrow-back-outline" slot="icon-only">
                </ion-icon></ion-button>
            </ion-buttons>
            <ion-title>Choose a Pet</ion-title>
          </ion-toolbar>
        </ion-header>
        <ion-content color="lightmimbo">
          <ion-list>
            <ion-item button="true" color="lightmimbo" *ngFor="let dog of loadedDogs"
              (click)="setDog(dog.id)"><ion-avatar class="avatar-img">
                <img [src]="dog.imageUrl" /> </ion-avatar><ion-text class="dog-name">{{dog.name}}</ion-text></ion-item>

            <ion-item (click)="addNewDog()" color="lightmimbo"><ion-icon name="add"
                style="margin-right: 8px"></ion-icon>Add New
              Pet</ion-item>
          </ion-list>
        </ion-content>
      </ng-template>
    </ion-modal>
  </div>
</ion-content>